module.exports = __webpack_public_path__ + "418ce02e5d1a9cdf48e2e73066673f2f.jpg";